import { Background, type BackgroundProps } from "@client/controls/Style/Background/component";
import { connectCustom } from "@client/lib/misc";
import { getBackgroundSettingSelector, getLayoutSettingValueSelector, TargetSelector } from "@client/selectors";
import { type AppState } from "@client/types";

const backgroundSettingSelector = getBackgroundSettingSelector(TargetSelector.Layout, "header");
const stickyBackgroundSettingSelector = getBackgroundSettingSelector(TargetSelector.Layout, "header.sticky");

const stickyCustomBackgroundSelector = getLayoutSettingValueSelector("customBackground", "header.sticky");

const mapStateToProps = (state: AppState): BackgroundProps => {
  const backgroundSetting = backgroundSettingSelector(state);
  const stickyBackgroundSetting = stickyBackgroundSettingSelector(state);
  const stickyCustomBackground = stickyCustomBackgroundSelector(state);

  return {
    containerSelector: "#header",
    value: state.widgets.header.isSticky && stickyCustomBackground ? stickyBackgroundSetting : backgroundSetting
  };
};

export default connectCustom(mapStateToProps)(Background);
